import React, { useState } from 'react';
import { Accordion, useAccordionButton } from 'react-bootstrap';
import { ButtonPrimary, ButtonPrimaryOutlined } from './Buttons.js';


export function AccordionCustomToggle({ children, eventKey }) {
    const decoratedOnClick = useAccordionButton(eventKey, () => { }) // do custom logging here if you want
    return (
        <ButtonPrimary onClick={decoratedOnClick}>
            {children}
        </ButtonPrimary>
    );
}


/**
 * displays an accordian with a close button below the body content
 * props:
 * 		- title		(string)
 * 		- children	(jsx)
 */
export const AccordionWithCloseBelow = (props) => {
    const [open, set_open] = useState(false);
    function onClick() {
        console.log("AccordionWithCloseBelow, set open to ", !open);
        set_open(!open);
    }
    return (
        <Accordion className="black-accordion" open={open}>
            <Accordion.Item eventKey="0" className="black-accordion">
                <Accordion.Header className="black-accordion">
                    {props.title}
                </Accordion.Header>
                <Accordion.Body className="black-accordion">
                    {props.children}
                    <br />
                    <AccordionCustomToggle eventKey="0">
                        Fermer
                    </AccordionCustomToggle>
                </Accordion.Body>
            </Accordion.Item>
        </Accordion>
    );
};
